exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-label-group{min-width:0;display:flex;align-items:center}.fts-label-group.label-group--information [class*=\" fts-icon-\"],.fts-label-group.label-group--information [class^=fts-icon-]{line-height:inherit}.fts-label-group.label-group--information .label-group__icon{color:var(--fts-text)}.label-group__emoji,.label-group__icon{margin-right:.375rem}.label-group__icon{color:var(--fts-default)}.label-group__label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--fts-text)}", ""]);

// exports
